export default __webpack_public_path__ + "static/media/question_14.dd1702e6.png";